import { MarketingMetricsDriver } from './MarketingMetricsDriver';

export const createLocalMarketingMetricsDriver = (): MarketingMetricsDriver => {
    return {
        push: (data) => {
            // eslint-disable-next-line no-console
            console.log('Local marketing metrics driver push', data);
        },
        init() {
            // eslint-disable-next-line no-console
            console.log('Local marketing metrics driver initialized');
        },
    };
};
